import { useState } from 'react'

import { useApiAction } from '../../api/useApiAction'
import { LoadingScreenTransformer } from '../../transformers/loadingScreenTransformer'
import { LoadingScreenProps } from '../../types'
import { StatusScreen } from '../statusScreen'
import Loader from './loader'

interface ScreenProps {
  props: LoadingScreenProps
}

export const LoadingScreen = (_props: ScreenProps) => {
  const { props } = _props

  const transformedProps = LoadingScreenTransformer.transform(props)

  const { state, clearCheckStatusInterval } = useApiAction({
    refresh: transformedProps?.refresh,
  })

  const [showLoader, setShowLoader] = useState(true)

  const onTimerEnd = () => {
    setShowLoader(false)
    clearCheckStatusInterval()
  }

  return showLoader ? (
    <Loader {...transformedProps} onTimerEnd={onTimerEnd} />
  ) : (
    <StatusScreen state={state} props={transformedProps.statusScreenProps} />
  )
}
